import React, { useCallback, useState } from 'react';
import { styled } from 'baseui';
import { useStyletron } from 'baseui';
import { toaster } from 'baseui/toast';
import { useAtomValue, useSetAtom } from 'jotai';
import ToolbarButton from '../../../../common/toolbar-button';
import { TOOLBAR_BUTTON_SIZE } from '../../../../common/toolbar-button';
import { Click } from '../../../icons';
import { EVENTS } from '../../../labelling-v2/atoms/label-store-dispatch/events';
import { useStageAtoms } from '../../../labelling-v2/components/stage-scope/hooks';
import { useAnalyticsForYolo } from '../../analytics/useAnalyticsForYolo';
import { BOUNDING_BOX_TOOLS, TOOL } from '../../constants';
import useStage from '../../providers/hooks/use-stage';
import { TOOL_CONFIG } from './constants';
import PanelContainer from './panel-container';
const BOUNDING_BOX_PANEL_MAX_WIDTH = 75;
const YOLO_BOUNDING_BOX_LABEL = 'Click on the buton to generate YOLO annotations';
const Icons = styled('div', {
  display: 'flex',
  justifyContent: 'flex-start',
  marginTop: '10px'
});
const BoundingBoxPanel = () => {
  const [_, theme] = useStyletron();
  const {
    Icon
  } = TOOL_CONFIG[TOOL.RECTANGLE];
  const {
    bulkAddAnnotations
  } = useStage();
  const {
    dispatchAtom,
    selectedSubToolAtom
  } = useStageAtoms();
  const dispatch = useSetAtom(dispatchAtom);
  const selectedSubTool = useAtomValue(selectedSubToolAtom);
  const [areYoloAnnotationsGenerated, setAreYoloAnnotationsGenerated] = useState(false);
  const {
    sendEventYoloAnnotation
  } = useAnalyticsForYolo();
  const onBoundingBoxClick = useCallback(() => {
    dispatch({
      type: EVENTS.SELECT_TOOL,
      tool: TOOL.RECTANGLE,
      subTool: BOUNDING_BOX_TOOLS.BOUNDING_BOX
    });
  }, [dispatch]);
  const onYOLOBoundingBoxClick = useCallback(() => {
    dispatch({
      type: EVENTS.SELECT_TOOL,
      tool: TOOL.RECTANGLE,
      subTool: BOUNDING_BOX_TOOLS.YOLO_BOUNDING_BOX
    });
    const result = bulkAddAnnotations();
    if (result instanceof Error) {
      toaster.negative(result.message);
    }
    sendEventYoloAnnotation();
    setAreYoloAnnotationsGenerated(true);
  }, [dispatch, bulkAddAnnotations, sendEventYoloAnnotation]);
  return <PanelContainer width={BOUNDING_BOX_PANEL_MAX_WIDTH} data-testid="bounding-box-panel">
      <Icons>
        <ToolbarButton title="Bounding Box" onClick={onBoundingBoxClick} attributes={{
        'data-testid': 'bounding_box'
      }} isSelected={selectedSubTool !== BOUNDING_BOX_TOOLS.YOLO_BOUNDING_BOX} size={TOOLBAR_BUTTON_SIZE.SMALL}>
          <Icon />
        </ToolbarButton>
        <ToolbarButton title={YOLO_BOUNDING_BOX_LABEL} onClick={onYOLOBoundingBoxClick} attributes={{
        'data-testid': 'yolo_bounding_box'
      }} isSelected={selectedSubTool === BOUNDING_BOX_TOOLS.YOLO_BOUNDING_BOX} size={TOOLBAR_BUTTON_SIZE.SMALL} disabled={areYoloAnnotationsGenerated}>
          <Click fillColor={theme.colors.primary} />
        </ToolbarButton>
      </Icons>
    </PanelContainer>;
};
export default BoundingBoxPanel;